import { render } from "./HasManyThroughField.vue?vue&type=template&id=4979e74a"
import script from "./HasManyThroughField.vue?vue&type=script&lang=js"
export * from "./HasManyThroughField.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HasManyThroughField.vue"]])

export default __exports__